import React, { KeyboardEvent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageType } from 'components/Messages';
import { getMessagePreviewText } from 'helpers/messagePreview';
import { QuotedContainer, AccentBar, QuotedContent, SenderName, PreviewText } from './style';

export interface QuotedMessageBubbleProps {
  contextId: string;
  contextFrom: string;
  quotedMessage?: MessageType;
  onClick?: () => void;
}

const QuotedMessageBubble: React.FC<QuotedMessageBubbleProps> = ({ contextFrom, quotedMessage, onClick }) => {
  const { t } = useTranslation();

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick?.();
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      onClick?.();
    }
  };

  const previewText = quotedMessage ? getMessagePreviewText(quotedMessage.chat, t) : t('originalMessageNotAvailable');

  return (
    <QuotedContainer
      data-testid="quotedMessageBubble"
      {...(onClick && { role: 'button', tabIndex: 0, onClick: handleClick, onKeyDown: handleKeyDown })}
    >
      <AccentBar />
      <QuotedContent>
        <SenderName data-testid="quotedMessageSender" noWrap>
          {contextFrom}
        </SenderName>
        <PreviewText data-testid="quotedMessageText" noWrap>
          {previewText}
        </PreviewText>
      </QuotedContent>
    </QuotedContainer>
  );
};

export default QuotedMessageBubble;
